import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const GenderActiveSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <g clipPath="url(#clip0-active-gender)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9547 6.6446C17.1618 10.8553 11.891 11.452 11.891 11.452C5.60521 12.3276 5.95323 17.3736 5.95323 17.3736C6.33323 21.6692 9.31343 22.9917 10.4919 23.1821C10.5097 23.185 10.528 23.1879 10.5468 23.191C11.7671 23.3886 14.9246 23.8999 18.8935 21.1291C22.9234 18.3161 25.6986 11.5867 21.9349 5.4281C18.1712 -0.730539 11.1003 0.0298168 11.1003 0.0298168L11.3852 1.97216C13.457 1.78215 16.7477 2.43394 16.9547 6.6446ZM12.1078 19.4134C13.1647 19.4134 14.0224 18.5564 14.0224 17.4982C14.0224 16.4406 13.1647 15.5836 12.1078 15.5836C11.0503 15.5836 10.1926 16.4406 10.1926 17.4982C10.1926 18.5564 11.0503 19.4134 12.1078 19.4134Z"
        fill="url(#paint0_linear-active-gender)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8059 6.90159C13.8059 7.95895 12.9482 8.81648 11.8913 8.81648C10.8338 8.81648 9.97607 7.95895 9.97607 6.90159C9.97607 5.84423 10.8338 4.98669 11.8913 4.98669C12.9482 4.98669 13.8059 5.84423 13.8059 6.90159"
        fill="url(#paint1_linear-active-gender)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9707 22.9388C18.0297 22.9388 22.9415 18.0271 22.9415 11.9681C22.9415 5.90912 18.0297 0.997345 11.9707 0.997345C5.91177 0.997345 1 5.90912 1 11.9681C1 18.0271 5.91177 22.9388 11.9707 22.9388Z"
        stroke="url(#paint2_linear-active-gender)"
        strokeWidth="2"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear-active-gender"
        x1="-1.16174"
        y1="3.93199"
        x2="13.751"
        y2="29.949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1F7CD" />
        <stop offset="0.999842" stopColor="#32AC80" />
      </linearGradient>
      <linearGradient
        id="paint1_linear-active-gender"
        x1="-11.0257"
        y1="-0.192929"
        x2="1.94201"
        y2="33.2432"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1F7CD" />
        <stop offset="0.999842" stopColor="#32AC80" />
      </linearGradient>
      <linearGradient
        id="paint2_linear-active-gender"
        x1="-7.78344"
        y1="4.69057"
        x2="4.10896"
        y2="31.9726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A1F7CD" />
        <stop offset="0.999842" stopColor="#32AC80" />
      </linearGradient>
      <clipPath id="clip0-gender">
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </SvgWrapper>
)
